const LangEgiftShoppingCartSuccess = {
	"egiftShoppingCartSuccess.yay": ["YAY!", "YAY!"],
	"egiftShoppingCartSuccess.yourPurchaseIsCompleted": [
		"Your purchase is completed",
		"Giao dịch của bạn đã thành công",
	],
	"egiftShoppingCartSuccess.yourGiftCardIsOnItsWayTo": [
		"Your Gift Card is on its way to ${toName}",
		"Thẻ quà tặng đang được gửi đến ${toName}",
	],
}

export default LangEgiftShoppingCartSuccess



// WEBPACK FOOTER //
// ./src/resources/pages/LangEgiftShoppingCartSuccess.js